export default __webpack_public_path__ + "static/img/31.c9f639d.png";